module.exports = __webpack_public_path__ + "img/partsix_pic.9194cf5e.png";